import { Dialog, DialogTitle, Button, DialogContent, useTheme } from "@mui/material";
import { IEnabledUpdateProjectDetail, ProjectDetailContext } from "../../../pages/ProjectDetail";
import { ProjectDetailTable } from "./ProjectDetailTable";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Common } from "../../../../common/src";


type TDetailProps = {
    open: boolean
    close: () => void
    setProjectName?: Dispatch<SetStateAction<string>>
    projectDetail?: Common.ProjectDetail
    updateProjectDetail?: (newDetail: IEnabledUpdateProjectDetail) => void;
}

const ProjectDetailDialog = (detailProps: TDetailProps) => {
    const { isJapanese, } = useContext(ProjectDetailContext);
    const [ isOverlay, setIsOverlay ] = useState<boolean>(false);
    const { t, i18n } = useTranslation();

    const handleClickProjectDetailClose = () => {
        detailProps.close();
    }

    const theme = useTheme();

    const customColor = {
        color: theme.palette.base.contrast,
    };

    const customDialogBackgroundColor = {
        color: theme.palette.base.dialogBackground,
    };

    const customBackground = {
        background: theme.palette.base.modal,
    };

    return (
        <>
            <Dialog
                open={detailProps.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ className: 'overflow29', style: { ...customBackground } }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: isOverlay ? "rgba(0, 0, 0, 0)" : customDialogBackgroundColor.color,
                        },
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" className="overflow30">{t("MORE_INFOR")}
                    <Button style={customColor} className="x-btn overflow14" onClick={handleClickProjectDetailClose}>×</Button>
                    <div className='border-comm' />
                </DialogTitle>
                <DialogContent style={{ overflowX: 'hidden' }}>
                    <ProjectDetailTable
                        isLanguage={isJapanese}
                        projectDetail={detailProps.projectDetail}
                        setProjectName={detailProps.setProjectName}
                        updateProjectDetail={detailProps.updateProjectDetail}
                        showDialog={(show) => {setIsOverlay(show)}}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ProjectDetailDialog;